import { Affix } from '@mantine/core';
import { MultiSelectAll } from 'src/components/common/MultiSelect/MultiSelectAll';
import { Content } from 'src/contexts/ContentContext';
import { useMultiSelectionContext } from 'src/contexts/MultiSelectionContext';
import { vars } from 'src/core/themes';
import { Button, Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';
import { EventWithData } from 'src/WebApiController';

import * as styles from './ListingTilesBulkActions.css';

export const ListingTilesBulkActions = ({
  eventWithData,
  onBulkActionsClick,
}: {
  eventWithData: EventWithData;
  onBulkActionsClick: () => void;
}) => {
  const { selectionMode, totalItemsSelected } = useMultiSelectionContext();

  if (!selectionMode) {
    return null;
  }

  return (
    <Affix
      position={{
        bottom: vars.spacing.lg,
        left: vars.spacing.lg,
        right: vars.spacing.lg,
      }}
      zIndex={50}
    >
      <Stack
        direction="row"
        gap="l"
        alignItems="center"
        justifyContent="spaceBetween"
        width="full"
      >
        <MultiSelectAll
          displayMode="count-only-button"
          className={styles.selectAllButton}
          customCountLabel={eventWithData.counts.listCnt + ''}
        />
        <Button
          shape="rect"
          onClick={onBulkActionsClick}
          disabled={totalItemsSelected === 0}
          className={styles.actionsButton}
        >
          <Content id={ContentId.Actions} />
        </Button>
      </Stack>
    </Affix>
  );
};
